import {
  Col,
  Form,
  FormInstance,
  Input,
  Radio,
  RadioChangeEvent,
  Row,
} from 'antd'
import { infoMessage } from 'api/global'
import {
  useAddMoreFee,
  useEditMoreFee,
} from 'api/league/LeagueCostAndFee/CostAndFee'
import React, { useState } from 'react'
import { leagueEventStore } from 'state/league/leagueEvent'
import { myStore } from 'state/store'
import { AdditionalFeePayload } from 'types/event/eventStep3'

interface FeeFormProps {
  form: FormInstance
}

const FeeForm: React.FC<FeeFormProps> = ({ form }) => {
  const setModalBtnLoader = myStore(store => store.setModalBtnLoader)
  const {
    leagueData,
    setLeagueData,
    additionalFeeData,
    setAdditionalFeeData,
    setFeeModal,
  } = leagueEventStore(store => ({
    leagueData: store.leagueData,
    setLeagueData: store.setLeagueData,
    additionalFeeData: store.additionalFeeData,
    setAdditionalFeeData: store.setAdditionalFeeData,
    setFeeModal: store.setFeeModal,
  }))

  const [priceType, setPriceType] = useState<'price' | 'priceRange'>(
    additionalFeeData?.priceRange ? 'priceRange' : 'price',
  )

  const { mutate: addMoreFeeMutation } = useAddMoreFee()
  const { mutate: editMoreFeeMutation } = useEditMoreFee()

  const formSchema = {
    name: additionalFeeData?.name || undefined,
    priceType: additionalFeeData?.priceRange ? 'priceRange' : 'price',
    price: additionalFeeData?.price || undefined,
    min: additionalFeeData?.priceRange?.min || undefined,
    max: additionalFeeData?.priceRange?.max || undefined,
  }

  const onFinish = (values: any) => {
    if (!values.name) {
      return infoMessage('Name is required')
    }
    if (priceType === 'price' && (!values.price || values.price === 0)) {
      return infoMessage('Price must be greater than 0')
    }
    if (
      priceType === 'priceRange' &&
      (!values.min || !values.max || values.min === 0 || values.max === 0)
    ) {
      return infoMessage('Price must be greater than 0')
    }
    let payload: AdditionalFeePayload
    if (priceType === 'price') {
      payload = values
    } else {
      payload = {
        name: values.name,
        priceRange: {
          min: values.min,
          max: values.max,
        },
      }
    }

    setModalBtnLoader(true)
    if (additionalFeeData && additionalFeeData._id) {
      editMoreFeeMutation(
        {
          leagueId: leagueData._id,
          feeId: additionalFeeData._id,
          payload,
        },
        {
          onSuccess: updatedData => {
            setLeagueData({
              ...leagueData,
              ...updatedData,
            })
            setModalBtnLoader(false)
            setAdditionalFeeData(undefined)
            setFeeModal(false)
          },
          onError: () => {
            setModalBtnLoader(false)
          },
        },
      )
    } else {
      addMoreFeeMutation(
        {
          leagueId: leagueData._id,
          payload,
        },
        {
          onSuccess: addedData => {
            setLeagueData({
              ...leagueData,
              ...addedData,
            })
            setModalBtnLoader(false)
            setFeeModal(false)
          },
          onError: () => {
            setModalBtnLoader(false)
          },
        },
      )
    }
  }

  return (
    <>
      <Form
        form={form}
        layout="horizontal"
        initialValues={formSchema}
        onFinish={onFinish}
      >
        <Row gutter={10}>
          <Col>
            <label className="input-label required-input">Enter fee name</label>
          </Col>
          <Col>
            <Form.Item className="form-control" name="name">
              <Input placeholder="Fee name" className="form-control-field" />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={10} className="mt-10px">
          <Col>
            <Form.Item name="priceType" className="w-100">
              <Radio.Group
                onChange={(val: RadioChangeEvent) => {
                  setPriceType(val.target.value)
                }}
                defaultValue={priceType}
              >
                <div>
                  <div className="flex justify-between align-center w-50p">
                    <Radio value={'price'} className="mr-40 radio">
                      Price
                    </Radio>
                    {priceType === 'price' && (
                      <div className="flex align-center">
                        <p className="mr-10px">$</p>
                        <Form.Item name="price" className="mb-0px">
                          <Input
                            placeholder="0"
                            className="br-12 custom-input-num-field font16 text-end"
                            type="number"
                            onWheel={e => e.currentTarget.blur()}
                          />
                        </Form.Item>
                      </div>
                    )}
                  </div>
                  <div className="flex gap-16px align-center">
                    <Radio value={'priceRange'} className="mr-40 radio">
                      Price range
                    </Radio>
                    {priceType === 'priceRange' && (
                      <div className="flex gap-16px align-center">
                        <div className="flex align-center">
                          <p className="mr-10px">$</p>
                          <Form.Item name="min" className="mb-0px">
                            <Input
                              placeholder="0"
                              className="br-12 custom-input-num-field font16 text-end"
                              type="number"
                              style={{ width: '100px' }}
                              onWheel={e => e.currentTarget.blur()}
                            />
                          </Form.Item>
                        </div>
                        <p>-</p>
                        <div className="flex align-center">
                          <p className="mr-10px">$</p>
                          <Form.Item name="max" className="mb-0px">
                            <Input
                              placeholder="0"
                              className="br-12 custom-input-num-field font16 text-end"
                              type="number"
                              style={{ width: '100px' }}
                              onWheel={e => e.currentTarget.blur()}
                            />
                          </Form.Item>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </Radio.Group>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </>
  )
}

export default FeeForm
